import React, { useEffect, useState, useContext, Component } from "react"
import { Link } from "react-router-dom";
import moment from "moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { apiEndpoint } from "helpers/url_helper";



import {
    Col,
    Row,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    ModalFooter,
    Dropdown,
  } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { isEmpty, isUndefined } from "lodash";

const AddVehicleDataModalComponent = (props) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [alertmsg, setAlert] = useState();

    const [VehicleOwnerName, setVehicleOwnerName] = useState(false);
    const [EmployeeID, setEmployeeID] = useState(false);
    const [VehicleRegistrationNumber, setVehicleRegistrationNumber] = useState(false);
    const [VehicleOwnerDept, setVehicleOwnerDept] = useState(false);
    const [VehicleOwnerEmailAddress, setVehicleOwnerEmailAddress] = useState(false);
    const [VehicleOwnerContact, setVehicleOwnerContact] = useState(false);
    const [VehicleOwnerAddress, setVehicleOwnerAddress] = useState(false);

    const [Campusitems, setCampusItems] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState({});

    const btnstylesObj = {
        "marginRight": '5%',
        "marginLeft": '44.5%'
    };

    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()
    // get Campus List
    useEffect(() => {
        // UserValidated
        fetch(apiEndpoint + "/GetLogCampusList",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "strToken": sessionStorage.getItem("Clear_AuthUser")
                  
                })
              })   
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result)
                    if (result != undefined) {
                        //sessionStorage.setItem("authUser", JSON.stringify(result.strNewToken))
                        if (result.CampusList != undefined) {
                            setCampusItems(JSON.parse(result.CampusList));
                            // var campuslst = JSON.parse(result.CampusList);
                            // setSelectedCampusItem(campuslst[0]);
                            // setCampusSelected(campuslst[0].value);
                        }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )

    }, [])

    // check first, last name
    const checkName = (name) => {
        const validRegExp = new RegExp(
          '^[A-Za-z ]+$'
        );
        if(validRegExp.test(name) && name.length >= 3 && name.length <= 30){
          return true;
        }
        else{
          return false;
        }
    }

    // check first, last name
    const checkRegistrationNumber = (name) => {
        // const validRegExp = new RegExp(
        //   '^[A-Za-z]+$'
        // );
        if(name.length == 10){
          return true;
        }
        else{
          return false;
        }
    }

    const checkCampusList = (list) => {
        if(list.length > 0){
            return true;
          }
          else{
            return false;
          }
    }

    const toggle = () => {
        setAlert(null)
        setModalIsOpen(!modalIsOpen)
    }

    const Option  = (props) => {
        return (
          <div>
            <components.Option {...props}>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />{" "}
              <label>{props.label}</label>
            </components.Option>
          </div>
        );
    };

    // Campus Change Event
    const changeCampusSelectHandler = (event) => {
        setCampusSelected(event);
    };

    const ToggleAndRefreshPage = () => {
        toggle();
        window.location.reload(false);
    }

    const saveButton = () => {
        // console.log(checkCampusList(selectedCampusVal))

        // console.log(checkName(VehicleOwnerName))
        // console.log(checkRegistrationNumber(VehicleRegistrationNumber))

        // console.log(''+EmployeeID)
        // console.log(''+VehicleOwnerDept)
        // console.log(''+VehicleOwnerEmailAddress)
        // console.log(''+VehicleOwnerContact)
        // console.log(''+VehicleOwnerAddress)
        if(checkCampusList(selectedCampusVal) && checkName(VehicleOwnerName) 
        && checkRegistrationNumber(VehicleRegistrationNumber)){

            // UserValidated
            fetch(apiEndpoint+"/SaveVehicleDataFromApp",
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "VehicleOwnerName": VehicleOwnerName,
                "VehicleRegistrationNumber": VehicleRegistrationNumber,
                "VehicleOwnerEmailAddress": VehicleOwnerEmailAddress,
                "VehicleOwnerContact": VehicleOwnerContact,
                "VehicleOwnerAddress": VehicleOwnerAddress,
                "EmployeeID": EmployeeID,
                "Department": VehicleOwnerDept,
                "CampusAccess": selectedCampusVal,
                "Token": sessionStorage.getItem("Clear_AuthUser")
            })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined)
                    {
                      if(result.status){
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        setAlert (
                          <ReactBSAlert
                            success
                            // title="Campus Selection Is Required!"
                            //onConfirm={() => setAlert(null)}
                            onConfirm={() =>  ToggleAndRefreshPage()}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                      }
                      else{
                        setAlert (
                          <ReactBSAlert
                            warning
                            title=""
                            onConfirm={() => toggle()}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                      }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //setError(error);
                }
            )
        }
    }

    return (
        <>
            <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                onClick={toggle}  style={btnstylesObj}><i className="mdi mdi-account-details"></i></Link>
            {modalIsOpen == true}

            <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>
                <ModalHeader toggle={toggle} tag="h4">
                    Add Vehicle Details
                </ModalHeader>
                <ModalBody>
                    <AvForm className="needs-validation" onSubmit={saveButton}>
                    {alertmsg}
                        <Row>

                            <Col md={6}>
                                <label for="SelectCampus" className="mt-3">Select Campus *</label>
                                {/* <Select value={SelectedCampusitem} options={Campusitems} onChange={changeCampusSelectHandler}></Select> */}

                                <span
                                    className="mt-3"
                                    data-toggle="popover"
                                    data-trigger="focus"
                                    data-content="Please selecet Campus(s)"
                                >
                                    <ReactSelect
                                        options={Campusitems}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={changeCampusSelectHandler}
                                        allowSelectAll={false}
                                        //value={selectedCampusVal}
                                        //controlShouldRenderValue={false}
                                        placeholder="Select Campus"
                                        required
                                    />
                                </span>

                            </Col>

                            <Col md={6}>
                                <label for="EmployeeID" className="mt-3">Employee ID</label>
                                <AvField
                                    name="EmployeeID"
                                    placeholder="Employee ID"
                                    type="text"
                                    className="form-control"
                                    id="EmployeeID"
                                    onChange={(event) => setEmployeeID(event.target.value)}
                                />
                            </Col>

                        </Row>

                        <Row>

                            <Col md={6}>
                                <label for="VehicleOwnerName" className="mt-3">Owner Name *</label>
                                <AvField
                                    name="VehicleOwnerName"
                                    placeholder="Owner Name"
                                    type="text"
                                    className="form-control"
                                    id="VehicleOwnerName"
                                    onChange={(event) => setVehicleOwnerName(event.target.value)}
                                    validate={{
                                        required: {value: true, errorMessage: 'Please enter vehicle owner name'},
                                        pattern: {value: '^[a-zA-Z ]*$', errorMessage: 'Vehicle owner name must be composed only with letters'},
                                        minLength: {value: 3, errorMessage: 'Vehicle owner name must be between 3 and 30 characters'},
                                        maxLength: {value: 30, errorMessage: 'Vehicle owner name must be between 3 and 30 characters'}
                                      }}
                                    required
                                />
                            </Col>
                            
                            <Col md={6}>
                                <label for="VehicleRegistrationNumber" className="mt-3">Registration Number *</label>
                                <AvField
                                    name="VehicleRegistrationNumber"
                                    placeholder="Registration Number"
                                    type="text"
                                    className="form-control"
                                    id="VehicleRegistrationNumber"
                                    onChange={(event) => setVehicleRegistrationNumber(event.target.value)}
                                    validate={{
                                        required: {value: true, errorMessage: 'Please enter registration number of vehicle'},
                                        pattern: {value: '^[a-zA-Z0-9_.-]*$', errorMessage: 'Registration number of vehicle must be composed only with letters & digits'},
                                        minLength: {value: 8, errorMessage: 'Registration number of vehicle must be min 8 characters'},
                                        maxLength: {value: 10, errorMessage: 'Registration number of vehicle must be 10 characters'}
                                    }}
                                    required
                                />
                            </Col>

                        </Row>

                        <Row>

                            <Col md={6}>
                                <label for="VehicleOwnerEmailAddress" className="mt-3">Owner Email ID</label>
                                <AvField
                                    name="VehicleOwnerEmailAddress"
                                    placeholder="Owner Email ID"
                                    type="text"
                                    className="form-control"
                                    id="VehicleOwnerEmailAddress"
                                    onChange={(event) => setVehicleOwnerEmailAddress(event.target.value)}
                                    validate={{
                                        //required: {value: true, errorMessage: 'Please enter your email id'},
                                        //pattern: {value: '^[a-zA-Z0-9+_\.-]+@[a-zA-Z0-9.-]+$', errorMessage: 'Invalid email id entered'}
                                        email:{value: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$', errorMessage: 'Invalid email id entered'}
                                    }}
                                />
                            </Col>

                            <Col md={6}>
                                <label for="VehicleOwnerContact" className="mt-3">Owner Contact Number</label>
                                <AvField
                                    name="VehicleOwnerContact"
                                    placeholder="Owner Contact Number"
                                    type="text"
                                    className="form-control"
                                    id="VehicleOwnerContact"
                                    onChange={(event) => setVehicleOwnerContact(event.target.value)}
                                />
                            </Col>

                        </Row>

                        <Row>

                            <Col md={6}>
                                <label for="VehicleOwnerDept" className="mt-3">Owner Department</label>
                                <AvField
                                    name="VehicleOwnerDept"
                                    placeholder="Owner Department"
                                    type="text"
                                    className="form-control"
                                    id="VehicleOwnerDept"
                                    onChange={(event) => setVehicleOwnerDept(event.target.value)}
                                />
                            </Col>

                            <Col md={6}>
                                <label for="VehicleOwnerAddress" className="mt-3">Owner Address</label>
                                <AvField
                                    name="VehicleOwnerAddress"
                                    placeholder="Owner Address"
                                    type="text"
                                    className="form-control"
                                    id="VehicleOwnerAddress"
                                    onChange={(event) => setVehicleOwnerAddress(event.target.value)}
                                />
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col md={10}></Col>

                            <Col md={2}>
                                <button className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                                >Submit</button>
                            </Col>

                        </Row>

                    </AvForm>

                </ModalBody>

            </Modal>
        </>
    )

}

export default AddVehicleDataModalComponent;